module.exports = __webpack_public_path__ + "img/115.2.fe30fdab.png";